import React, { Component } from 'react'
import update from 'immutability-helper'
import PropTypes from 'prop-types'

import Select, { Creatable } from 'react-select'

class SelectForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      itemSelectorValue: '',
      selectedItem: undefined,
      showMemberSelector: false
    }

    this.memberSelector = React.createRef()
  }

  componentWillMount() {
    const { item, focusMemberSelector } = this.props

    if (focusMemberSelector) {
      this.setState({
        selectedItem: {title: item.title, type: item.type.slug},
        showMemberSelector: true
      })
    }
  }

  componentDidUpdate() {
    const { showMemberSelector } = this.state

    if (showMemberSelector === true) this.memberSelector.current.focus()
  }

  render() {
    const { value, item, itemTypes, members } = this.props
    let { itemSelectorValue, selectedItem } = this.state

    let enableMemberSelector = item.indexes ? true : false // added new monitor

    return (
      <div className="select-form">
        <div className="select-form-escape" onClick={() => this.props.removeFocus()} />

        <div className="select-form-fields">
          <Creatable
            autoFocus={selectedItem === undefined ? true : false}
            openOnFocus={true}
            className="select-form-field"
            value={selectedItem || value}
            valueKey="id"
            labelKey="title"
            clearable={false}
            placeholder={item.value || item.title || "Select monitor type"}
            noResultsText={`Please choose "Wedge monitor" or "In-ear monitor"`}
            onInputChange={(input) => {
              this.setState({itemSelectorValue: input})

              return input
            }}
            onChange={({id, title, type, name}) => {
              if (type) { // selected 'monitor type'
                selectedItem = {title, type}
              } else { // selected 'assign a member'
                selectedItem = {title: item.title, type: item.type.slug}
                enableMemberSelector = true
              }
              if (name) selectedItem = {title: `Monitor (${name})`, member: id, value: null} // assigned 'member'

              if (enableMemberSelector) {
                this.setState({selectedItem, showMemberSelector: true})
              } else {
                this.props.onItemSelect(selectedItem)
              }
            }}
            promptTextCreator={(label) => `Assign monitor to "${label}"`}
            onNewOptionClick={({title}) => {
              const name = title
              selectedItem = {title: `Monitor (${name})`, value: name}

              this.setState({selectedItem, showMemberSelector: true})
            }}
            options={
              itemSelectorValue.length === 0
              ? itemTypes
              : members.map(member => {
                  return {id: member.id, title: member.name, name: member.name}
                })
            } />

          {
            this.state.showMemberSelector
            ? selectedItem.member || selectedItem.value
              ? <Select
                  ref={this.memberSelector}
                  cache={false}
                  autoFocus={selectedItem ? true : false}
                  openOnFocus={true}
                  className="select-form-field"
                  value={undefined}
                  valueKey="id"
                  labelKey="title"
                  clearable={false}
                  placeholder="Select monitor type"
                  onChange={({title, type}) => {
                    if (type) selectedItem = {...selectedItem, title, type}

                    this.props.onItemSelect(selectedItem)
                  }}
                  options={itemTypes} />
              : <Creatable
                  ref={this.memberSelector}
                  cache={false}
                  autoFocus={selectedItem ? true : false}
                  openOnFocus={true}
                  className="select-form-field"
                  value={undefined}
                  valueKey="id"
                  labelKey="name"
                  clearable={false}
                  placeholder="Assign this monitor to..."
                  onChange={({id, name}) => {
                    if (id) selectedItem = {...selectedItem, member: id, value: null}

                    this.props.onItemSelect(selectedItem)
                  }}
                  promptTextCreator={(label) => `Name as "${label}"`}
                  onNewOptionClick={({name}) => {
                    selectedItem = {...selectedItem, member: null, value: name}

                    this.props.onItemSelect(selectedItem)
                  }}
                  options={[...members, {id: null, name: 'Not right now'}]} />
            : null
          }
        </div>
      </div>
    )
  }
}

SelectForm.propTypes = {
  value: PropTypes.string,
  item: PropTypes.object,
  itemTypes: PropTypes.array,
  members: PropTypes.array,
  focusMemberSelector: PropTypes.bool,
  onItemSelect: PropTypes.func,
  removeFocus: PropTypes.func
}

SelectForm.defaultProps = {
  value: '',
  item: {},
  itemTypes: [],
  members: [],
  focusMemberSelector: undefined,
  onItemSelect: function() {},
  removeFocus: function() {}
}

export default SelectForm



// WEBPACK FOOTER //
// ./src/components/rider/rider-output/forms/select-form.js